module.exports = __webpack_public_path__ + "assets/img/licence_show_type_single.9f63757.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/licence_show_type_single.png
// module id = +dzg
// module chunks = 50